import { render } from "./TasksStatusSection.vue?vue&type=template&id=53ce10fb&scoped=true"
import script from "./TasksStatusSection.vue?vue&type=script&lang=js"
export * from "./TasksStatusSection.vue?vue&type=script&lang=js"

import "./TasksStatusSection.vue?vue&type=style&index=0&id=53ce10fb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53ce10fb"

export default script